import { DEFAULT_MESSAGE_FIELDS } from "views/Constants";
import { escape, addToQuery, predicate } from "views/logic/queries/QueryHelper";
import TitleTypes from "views/stores/TitleTypes";
import { addWidget } from "views/logic/slices/widgetActions";
import { setTitle } from "views/logic/slices/titlesActions";
import { selectActiveQuery } from "views/logic/slices/viewSelectors";
import MessagesWidget from "../widgets/MessagesWidget";
import MessagesWidgetConfig from "../widgets/MessagesWidgetConfig";
import { createElasticsearchQueryString } from "../queries/Query";
import duplicateCommonWidgetSettings from "../fieldactions/DuplicateCommonWidgetSettings";
const extractFieldsFromValuePath = (valuePath) => valuePath.map((item) => Object.entries(item).map(([key, value]) => key === "_exists_" ? String(value) : key)).reduce((prev, cur) => [...prev, ...cur], []).reduce((prev, cur) => prev.includes(cur) ? prev : [...prev, cur], []);
const ShowDocumentsHandler = ({ contexts: { valuePath, widget } }) => (dispatch, getState) => {
  const activeQuery = selectActiveQuery(getState());
  const mergedObject = Object.fromEntries(valuePath.flatMap(Object.entries));
  const widgetQuery = widget && widget.query ? widget.query.query_string : "";
  const valuePathQuery = Object.entries(mergedObject).map(([k, v]) => predicate(k, escape(String(v)))).reduce((prev, next) => addToQuery(prev, next), "");
  const query = addToQuery(widgetQuery, valuePathQuery);
  const valuePathFields = extractFieldsFromValuePath(valuePath);
  const messageListFields = /* @__PURE__ */ new Set([...DEFAULT_MESSAGE_FIELDS, ...valuePathFields]);
  const newWidget = duplicateCommonWidgetSettings(MessagesWidget.builder(), widget).query(createElasticsearchQueryString(query)).newId().config(
    MessagesWidgetConfig.builder().fields([...messageListFields]).showMessageRow(true).build()
  ).build();
  const title = `Messages for ${valuePathQuery}`;
  return dispatch(addWidget(newWidget)).then(
    () => dispatch(setTitle(activeQuery, TitleTypes.Widget, newWidget.id, title))
  );
};
ShowDocumentsHandler.isEnabled = ({ contexts: { valuePath, widget } }) => valuePath !== void 0 && valuePath.length > 0 && widget !== void 0;
export default ShowDocumentsHandler;
